import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "product_button_arrow_right",
  "use": "product_button_arrow_right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"product_button_arrow_right\"><path d=\"M12.667 5c0 .742.58 1.85 1.167 2.78.756 1.2 1.658 2.247 2.693 3.046.776.599 3.216 1.174 3.973 1.174m0 0c-.757 0-3.198.575-3.973 1.174-1.035.8-1.937 1.847-2.693 3.045-.587.931-1.167 2.041-1.167 2.781m7.833-7H0\" stroke=\"#fff\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol